import { createContext, ReactNode, useContext } from 'react'

interface InitialState {
  locale: string
}

const InitialStateContext = createContext<InitialState | undefined>(undefined)

export const InitialStateProvider = ({ children, initialState }: { children: ReactNode, initialState?: InitialState }) => {
  const value = initialState ?? (window as any).INITIAL_STATE

  return (
    <InitialStateContext.Provider value={value}>
      {children}
    </InitialStateContext.Provider>
  )
}

export const useInitialStateContext = () => {
  return useContext(InitialStateContext)
}
